// Client config, sourced from Vite env vars. VITE_* values are baked into the
// bundle at build time. Their canonical defaults live in config/upstream.default.js
// (shared with the edge/dev proxies); a VITE_* var — set in .env.local locally or
// the Netlify UI per deploy context — overrides the default when present.
import {
  DEFAULT_WEBORDER_API_PREFIX,
  DEFAULT_SPECIALITY_CODE as FALLBACK_SPECIALITY_CODE,
} from "../../../config/upstream.default.js";

// Read a VITE_* var, falling back to the canonical default when it is unset or empty.
const envOr = (key, fallback) => {
  const value = import.meta.env[key];
  return value != null && value !== "" ? value : fallback;
};

// Weborder API prefix. Trailing slashes are stripped so `apiUrl("/auth/sign-in")`
// always yields a clean `${prefix}/auth/sign-in`.
export const API_PREFIX = envOr("VITE_WEBORDER_API_PREFIX", DEFAULT_WEBORDER_API_PREFIX).replace(/\/+$/, "");

// Default speciality (SP) code used to bootstrap speciality data.
export const DEFAULT_SPECIALITY_CODE = envOr("VITE_DEFAULT_SPECIALITY_CODE", FALLBACK_SPECIALITY_CODE);

// App environment label. Defaults to Vite's build MODE (development / production),
// overridable via VITE_APP_ENV.
export const APP_ENV = import.meta.env.VITE_APP_ENV || import.meta.env.MODE;

export const apiUrl = (path) => {
  if (!path) return API_PREFIX;
  return path.startsWith("/") ? `${API_PREFIX}${path}` : `${API_PREFIX}/${path}`;
};

// Centralised API error logging. In development we log the full axios error for
// debugging. In production we deliberately do NOT dump the raw error — axios
// attaches `config.data` (the request body), which for this app contains PII
// (name, DOB, license #, NPI, card billing details). Production logs are limited
// to HTTP status + message so nothing sensitive lands in the browser console.
export const logApiError = (error) => {
  if (import.meta.env.DEV) {
    console.error(error);
    return;
  }
  const status = error?.response?.status;
  console.error(`API error${status ? ` (${status})` : ""}: ${error?.message || "request failed"}`);
};
